import { useState, useCallback, useRef } from 'react';

export function parseNominatimAddress(result) {
  const a = result.address;
  return {
    streetName:   a.road || a.pedestrian || a.footway || a.path || '',
    streetNumber: a.house_number || '',
    zipCode:      a.postcode || '',
    cityName:     a.city || a.town || a.village || a.municipality || a.suburb || '',
    stateName:    a.state || a.province || a.region || '',
    latitude:     String(parseFloat(result.lat).toFixed(7)),
    longitude:    String(parseFloat(result.lon).toFixed(7)),
  };
}

export function useNominatim() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const debounceRef = useRef(null);

  const search = useCallback((query) => {
    clearTimeout(debounceRef.current);
    if (!query || query.trim().length < 4) { setResults([]); return; }

    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams({
          q: query, countrycodes: 'ar', format: 'jsonv2',
          addressdetails: '1', limit: '5', 'accept-language': 'es',
        });
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?${params}`,
          { headers: { 'Referer': window.location.origin } }
        );
        const data = await res.json();
        setResults(data);
      } catch (e) {
        setError('Error al buscar. Completá los campos manualmente.');
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 400);
  }, []);

  const clear = useCallback(() => { setResults([]); setError(null); }, []);

  return { results, loading, error, search, clear };
}
